
















import { Component, Vue, Watch } from "vue-property-decorator";
import { NavigationGuardNext, Route } from "vue-router";

Component.registerHooks([
	"beforeRouteEnter",
	"beforeRouteLeave",
	"beforeRouteUpdate"
]);


@Component
export default class App extends Vue {
	/// Attributes
	windowTitle = "";
	title = "";
	isLoading = false;
	isDark = false;

	/// Methods
	async created() {
		this.isDark = localStorage.getItem("theme-mode") === "true";
	}

	@Watch("windowTitle")
	onWindowTitleChanged(val: string) {
		document.title = val;
	}

	async beforeRouteEnter(to: Route, from: Route, next: NavigationGuardNext) {
		next(async (vm: any) => {
			vm.windowTitle = "Warcraft Roster";
		});
	}

	async beforeRouteUpdate(to: Route, from: Route, next: NavigationGuardNext) {
		// this.title = to.meta.title;
		next();
	}

	handleUpdateDark(val: boolean) {
		this.isDark = val;
	}

	@Watch("isDark")
	onIsDarkChanged(val: boolean) {
		localStorage.setItem("theme-mode", val.toString());

		// Change theme color for PWA
		let color = "#FFFFFF";
		if (val) {
			color = "#1d192b";
		}
		else {
			color = "#2c2541";
		}
		const metaTheme = document.querySelector("meta[name=\"theme-color\"]");
		if (metaTheme) {
			metaTheme.setAttribute("content", color);
		}

		this.$vuetify.theme.dark = val;
	}
}
